 
export default class   PhotoBeneficiarioResponse {
    constructor(public success?: boolean,
        public message?: string,
        public respCode?: number,
        public base64?: string
    ){}
}

 

export {PhotoBeneficiarioResponse}